import { PLATFORM_REGEXES } from '../constants'
import URLParser from '../URLParser'

const referrerIncludesPlatform = (...platforms) => {
  return traffic => {
    if (traffic.referrer === '') {
      return false
    }
    const referrerObject = new URLParser(traffic.referrer)
    const hostname = referrerObject.hostname
    return platforms.some(platform => {
      return PLATFORM_REGEXES[platform].some(regex => regex.test(hostname))
    })
  }
}

export default referrerIncludesPlatform



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/referrerIncludesPlatform.js